// Profile edit: grow the "about" textarea with content (cap height, scroll when very long).

const SELECTOR = 'textarea.user-profile-edit-about'

function maxHeightPx () {
  return Math.min(Math.round(window.innerHeight * 0.65), 520)
}

function resizeAboutTextarea (ta) {
  const maxPx = maxHeightPx()
  ta.style.overflowY = 'hidden'
  ta.style.height = 'auto'
  const target = Math.min(ta.scrollHeight, maxPx)
  ta.style.height = `${target}px`
  ta.style.overflowY = ta.scrollHeight > maxPx ? 'auto' : 'hidden'
}

function resizeAllAboutTextareas () {
  document.querySelectorAll(SELECTOR).forEach(resizeAboutTextarea)
}

let resizeRaf = null
function scheduleResizeAll () {
  if (resizeRaf != null) return
  resizeRaf = requestAnimationFrame(() => {
    resizeRaf = null
    resizeAllAboutTextareas()
  })
}

function bindAboutTextarea (ta) {
  if (ta.dataset.aboutAutosizeBound === '1') return
  ta.dataset.aboutAutosizeBound = '1'
  ta.addEventListener('input', scheduleResizeAll)
}

function initUserProfileAboutAutosize (root = document) {
  root.querySelectorAll(SELECTOR).forEach(bindAboutTextarea)
  scheduleResizeAll()
}

window.addEventListener('resize', scheduleResizeAll)

document.addEventListener('turbolinks:load', () => {
  initUserProfileAboutAutosize()
})
